export default __webpack_public_path__ + "static/media/pause.517b2fc5.svg";